import CityPagePersianas from "../components/CityPagePersianas";

export default function PersianasTorremolinos() {
  return (
    <CityPagePersianas
      name="Torremolinos"
      slug="torremolinos"
      cp="29620"
      poblacion={71270}
      zonaGeo="Costa del Sol Occidental"
      lat={36.6203}
      lng={-4.4998}
      zonas={[
        "Centro",
        "La Carihuela",
        "El Calvario",
        "Playamar",
        "Bajondillo",
        "Montemar",
        "El Pinillo",
      ]}
      landmarks={[
        "Plaza de la Costa del Sol",
        "Calle San Miguel",
        "Playa de La Carihuela",
        "Pueblo Blanco",
        "Aqualand",
      ]}
      municipiosLimitrofes={[
        "Málaga",
        "Benalmádena",
        "Alhaurín de la Torre",
      ]}
      festivalLocal="Feria de San Miguel, finales de septiembre"
      contextoTipologico="121 nacionalidades residentes, alta densidad turística y residencial, edificios costeros con salitre intenso, restaurantes y hostelería con toldos comerciales."
      isCoreZone={true}
    />
  );
}